/**
 * A password change revokes every coordinator session issued before it (backend
 * middleware/passwordChangeRevocation.js) — including the one that made the change. The server hands the
 * caller a fresh token in the change-password response; this stores it so the next request is not refused.
 *
 * Deliberately NOT a sign-in: the user is the same, so it must not call forgetPreviousUser() (that would
 * drop the active assessment and company). It only swaps the token value in place.
 *
 * The login keys are the ones Login.jsx writes and services/authHeaders.ts / utils/auth.js read.
 */
const LOGIN_TOKEN_KEYS = ['authToken', 'token', 'foundations-token'] as const

function storages(): Storage[] {
  const out: Storage[] = []
  try { if (globalThis.localStorage) out.push(globalThis.localStorage) } catch { /* unavailable */ }
  try { if (globalThis.sessionStorage) out.push(globalThis.sessionStorage) } catch { /* unavailable */ }
  return out
}

/** Replace `previousToken` with `newToken` wherever it is stored; if it is stored nowhere, store it as a login does. */
export function storeReissuedToken(previousToken: string | null, newToken: string): void {
  let replaced = false
  if (previousToken) {
    for (const storage of storages()) {
      for (const key of LOGIN_TOKEN_KEYS) {
        try {
          if (storage.getItem(key) === previousToken) {
            storage.setItem(key, newToken)
            replaced = true
          }
        } catch { /* storage unavailable */ }
      }
    }
  }
  if (replaced) return
  try {
    for (const key of LOGIN_TOKEN_KEYS) globalThis.localStorage.setItem(key, newToken)
  } catch { /* storage unavailable — the next request will ask the user to sign in again */ }
}
